// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import AddPermissionModal from './addPermissionmodule';
// import DataApi from '../../api/dataApi';
// import { AuthHelper } from '../../utils/authHelper';
// import PubSub from "pubsub-js";
// import { Button, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
// import ConfirmationModal from "../common/ConfirmationModal";

// // --- CHILD COMPONENTS ---

// const TooltipButton = ({ title, children }) => (
//     <OverlayTrigger placement="top" overlay={<Tooltip>{title}</Tooltip>}>
//         <span className="d-inline-block">{children}</span>
//     </OverlayTrigger>
// );

// const CustomHeader = ({ rolePermissionsLength, isExpanded, handleGlobalToggle, onAddNewRole }) => (
//     <div className="d-flex justify-content-between align-items-center p-2 my-4 mx-3"
//         style={{
//             color: "var(--primary-color)",
//             background: "var(--primary-background-color)",
//             borderRadius: "10px",
//         }}>
//         <h5 className="fw-bold mb-1">
//             <i className="fa-solid fa-user-shield me-2 fs-6"></i> Role Permissions ({rolePermissionsLength})
//         </h5>
//         <div className="d-flex align-items-center gap-3">
//             <TooltipButton title={isExpanded ? "Collapse All" : "Expand All to Edit"}>
//                 <Form.Check
//                     type="switch"
//                     id="expand-collapse-toggle"
//                     checked={isExpanded}
//                     onChange={handleGlobalToggle}
//                     style={{
//                         transform: "scale(1.8)",
//                         transformOrigin: "left center",
//                         cursor: "pointer",
//                         marginRight: "10px",
//                         accentColor: isExpanded ? "#198754" : "#6c757d"
//                     }}
//                 />
//             </TooltipButton>

//             <TooltipButton title="Add New Role">
//                 <Button className="custom-btn-table-header p-2" onClick={onAddNewRole}>
//                     <i className="fa-solid fa-plus fs-6 my-1"></i>
//                 </Button>
//             </TooltipButton>
//         </div>
//     </div>
// );

// const PermissionCell = ({ roleId, moduleId, field, value, editingPermissions, handleInlineToggle }) => {
//     let checked = value || false;

//     if (editingPermissions[roleId] && editingPermissions[roleId][moduleId]) {
//         checked = editingPermissions[roleId][moduleId][field];
//     }

//     return (
//         <div
//             className="d-inline-block cursor-pointer"
//             onClick={() => handleInlineToggle(roleId, moduleId, field)}
//             title={checked ? "Enabled" : "Disabled"}
//         >
//             {checked ? (
//                 <i className="fa-solid fa-check-square text-primary fs-5"></i>
//             ) : (
//                 <i className="fa-regular fa-square text-secondary fs-5" style={{ opacity: 0.6 }}></i>
//             )}
//         </div>
//     );
// };

// const SelectAllHeader = ({ roleId, permissionType, label, editingPermissions, rolePermissions, handleSelectAllToggle }) => {
//     let isChecked = false;

//     if (editingPermissions[roleId]) {
//         const roleData = editingPermissions[roleId];
//         const roleModules = rolePermissions || [];
//         if (roleModules.length > 0) {
//             isChecked = roleModules.every(m => roleData[m.module_id]?.[permissionType] === true);
//         }
//     }

//     return (
//         <th width="17.5%" className="text-center">
//             <div className="d-flex flex-column align-items-center justify-content-center">
//                 <div
//                     className="cursor-pointer"
//                     onClick={() => handleSelectAllToggle(roleId, permissionType)}
//                     title={isChecked ? "Deselect All" : "Select All"}
//                 >
//                     {isChecked ? (
//                         <i className="fa-solid fa-check-square text-primary fs-5"></i>
//                     ) : (
//                         <i className="fa-regular fa-square text-secondary fs-5"></i>
//                     )}
//                 </div>
//                 <span className="fw-semibold mb-1">{label}</span>
//             </div>
//         </th>
//     );
// };

// // --- ROLE ACCORDION ---
// const RoleAccordion = ({ role, expandedRoles, handleRowToggle, permissions, modules, moduleMap, editingPermissions, handleSelectAllToggle, handleInlineToggle }) => {
//     const isOpen = expandedRoles[role.role_id] || false;
//     const [expandedParents, setExpandedParents] = useState({});

//     const roleModuleIds = useMemo(() => new Set(role.permissions.map(p => String(p.module_id))), [role.permissions]);

//     const moduleTree = useMemo(() => {
//         const parentModules = [];
//         const childrenByParent = {};

//         role.permissions.forEach(perm => {
//             const moduleInfo = moduleMap[perm.module_id];
//             const rawParentId = moduleInfo?.parent_module;
//             const parent_id = (rawParentId && String(rawParentId) !== "0") ? String(rawParentId) : null;

//             if (parent_id && roleModuleIds.has(parent_id)) {
//                 childrenByParent[parent_id] = childrenByParent[parent_id] || [];
//                 childrenByParent[parent_id].push(perm);
//             } else {
//                 parentModules.push(perm);
//             }
//         });

//         const sortByName = (a, b) => (a.module_name || "").localeCompare(b.module_name || "");
//         parentModules.sort(sortByName);
//         Object.values(childrenByParent).forEach(childArr => childArr.sort(sortByName));

//         return { parentModules, childrenByParent };
//     }, [role.permissions, moduleMap, roleModuleIds]);

//     const toggleParent = (moduleId) => {
//         setExpandedParents(prev => ({
//             ...prev,
//             [moduleId]: !prev[moduleId]
//         }));
//     };

//     return (
//         <div className="card mb-3 border shadow-sm mx-3">
//             <div className="card-header p-3 d-flex justify-content-between align-items-center bg-light">
//                 <div className="d-flex align-items-center cursor-pointer w-100" onClick={() => handleRowToggle(role.role_id)}>
//                     <h6 className="mb-0 fw-bold">
//                         <i className="fa-solid fa-user-tag me-2 text-primary"></i>
//                         {role.role_name}
//                     </h6>
//                 </div>

//                 <div className="d-flex gap-2 align-items-center">
//                     <i
//                         className={`fa-solid ${isOpen ? "fa-chevron-down" : "fa-chevron-up"} me-2`}
//                         style={{ cursor: "pointer", fontSize: '1.1rem' }}
//                         onClick={() => handleRowToggle(role.role_id)}
//                     ></i>
//                 </div>
//             </div>

//             {isOpen && (
//                 <div className="card-body p-0">
//                     <div className="table-responsive">
//                         <table className="table table-hover mb-0">
//                             <thead className="table-light border-bottom">
//                                 <tr>
//                                     <th width="35%" className="ps-4 pb-3">Module Name</th>
//                                     <SelectAllHeader roleId={role.role_id} permissionType="allow_view" label="View" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                                     <SelectAllHeader roleId={role.role_id} permissionType="allow_create" label="Create" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                                     <SelectAllHeader roleId={role.role_id} permissionType="allow_edit" label="Edit" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {moduleTree.parentModules.length > 0 ? (
//                                     moduleTree.parentModules.map(parentPerm => {
//                                         const parentId = String(parentPerm.module_id);
//                                         const children = moduleTree.childrenByParent[parentId] || [];
//                                         const parentExpanded = expandedParents[parentId] || false;

//                                         return (
//                                             <React.Fragment key={`${role.role_id}-${parentId}`}>
//                                                 <tr style={{ backgroundColor: children.length > 0 ? '#f8f9fa' : 'transparent' }}>
//                                                     <td 
//                                                         className="ps-4 py-2 d-flex align-items-center" 
//                                                         onClick={() => children.length > 0 && toggleParent(parentId)}
//                                                         style={{ cursor: children.length > 0 ? 'pointer' : 'default' }}
//                                                     >
//                                                         {children.length > 0 ? (
//                                                             <div className="me-2 text-primary d-flex justify-content-center align-items-center bg-white border rounded shadow-sm" style={{ width: '22px', height: '22px' }}>
//                                                                 <i className={`fa-solid ${parentExpanded ? "fa-minus" : "fa-plus"}`} style={{ fontSize: '0.75rem' }} />
//                                                             </div>
//                                                         ) : (
//                                                             <div className="me-2" style={{ width: '22px', height: '22px' }}></div>
//                                                         )}
//                                                         <span className="fw-bold" style={{ userSelect: 'none' }}>
//                                                             {parentPerm.module_name || `Module ${parentId}`}
//                                                         </span>
//                                                     </td>
//                                                     <td className="text-center align-middle py-2">
//                                                         <PermissionCell roleId={role.role_id} moduleId={parentId} field="allow_view" value={parentPerm.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                     </td>
//                                                     <td className="text-center align-middle py-2">
//                                                         <PermissionCell roleId={role.role_id} moduleId={parentId} field="allow_create" value={parentPerm.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                     </td>
//                                                     <td className="text-center align-middle py-2">
//                                                         <PermissionCell roleId={role.role_id} moduleId={parentId} field="allow_edit" value={parentPerm.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                     </td>
//                                                 </tr>

//                                                 {parentExpanded && children.map(childPerm => (
//                                                     <tr key={`${role.role_id}-${childPerm.module_id}`} style={{ backgroundColor: '#fff' }}> 
//                                                         <td className="ps-5 py-2">
//                                                             <div className="ms-3 ps-3 border-start border-2 border-primary">
//                                                                 <span className="text-muted fw-semibold">{childPerm.module_name || `Module ${childPerm.module_id}`}</span>
//                                                             </div>
//                                                         </td>
//                                                         <td className="text-center align-middle py-2">
//                                                             <PermissionCell roleId={role.role_id} moduleId={childPerm.module_id} field="allow_view" value={childPerm.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                         </td>
//                                                         <td className="text-center align-middle py-2">
//                                                             <PermissionCell roleId={role.role_id} moduleId={childPerm.module_id} field="allow_create" value={childPerm.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                         </td>
//                                                         <td className="text-center align-middle py-2">
//                                                             <PermissionCell roleId={role.role_id} moduleId={childPerm.module_id} field="allow_edit" value={childPerm.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </React.Fragment>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="4" className="text-center py-4 text-muted">
//                                             No permissions set for this role
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };


// // --- MAIN PERMISSION COMPONENT ---

// const Permission = () => {
//     const [permissions, setPermissions] = useState([]);
//     const [roles, setRoles] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [editingRole, setEditingRole] = useState(null);
//     const [refreshKey, setRefreshKey] = useState(0);
//     const [expandedRoles, setExpandedRoles] = useState({});
//     const [isExpanded, setIsExpanded] = useState(false);
//     const [showConfirmModal, setShowConfirmModal] = useState(false);
//     const [editingPermissions, setEditingPermissions] = useState({});
//     const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//     const [modules, setModules] = useState([]);

//     const [roleToDelete, setRoleToDelete] = useState({ id: null, name: null });

//     const fetchPermissions = useCallback(async () => {
//         try {
//             setLoading(true);
//             const api = new DataApi("permissions");
//             const result = await api.fetchAll();
//             let permissionsData = result?.data?.data || result?.data || result || [];
//             setPermissions(permissionsData);
//             setLoading(false);
//         } catch (err) {
//             setError(err.message || "Failed to fetch permissions");
//             setLoading(false);
//         }
//     }, []);

//     const fetchRoles = useCallback(async () => {
//         try {
//             const api = new DataApi("user-role");
//             const res = await api.fetchAll();
//             setRoles(Array.isArray(res?.data) ? res.data : []);
//         } catch (err) {}
//     }, []);

//     const fetchModules = useCallback(async () => {
//         try {
//             const api = new DataApi("module");
//             const result = await api.fetchAll();
//             setModules(result?.data?.records || []);
//         } catch (err) {}
//     }, []);

//     useEffect(() => {
//         fetchPermissions();
//         fetchRoles();
//         fetchModules();
//     }, [refreshKey, fetchPermissions, fetchRoles, fetchModules]);

//     const rolePermissions = useMemo(() => {
//         const grouped = {};
//         const roleMap = roles.reduce((acc, role) => { acc[role.id] = role; return acc; }, {});
//         const permissionRowsByRole = permissions.reduce((acc, perm) => {
//             const roleId = perm.role_id || 'null';
//             if (!acc[roleId]) acc[roleId] = [];
//             acc[roleId].push(perm);
//             return acc;
//         }, {});

//         const roleIds = new Set([...Object.keys(permissionRowsByRole), ...roles.map(r => r.id)]);

//         roleIds.forEach(roleId => {
//             const roleInfo = roleMap[roleId];
//             let roleName = roleInfo ? (roleInfo.role_name || roleInfo.name || `Role ${roleId}`) : `Role ${roleId}`;
//             if (roleName && roleName.toUpperCase() === "SYSTEM ADMIN") return;

//             const rolePerms = permissionRowsByRole[roleId] || [];
//             const permMap = rolePerms.reduce((acc, perm) => { acc[perm.module_id] = perm; return acc; }, {});

//             const permissionList = modules.map(moduleItem => {
//                 const existing = permMap[moduleItem.id];
//                 return {
//                     module_id: moduleItem.id,
//                     module_name: moduleItem.name,
//                     parent_module: moduleItem.parent_module,
//                     allow_view: !!existing?.allow_view,
//                     allow_create: !!existing?.allow_create,
//                     allow_edit: !!existing?.allow_edit,
//                     allow_delete: !!existing?.allow_delete
//                 };
//             });

//             grouped[roleId] = { role_id: roleId, role_name: roleName, permissions: permissionList };
//         });

//         return Object.values(grouped);
//     }, [permissions, roles, modules]);

//     const moduleMap = useMemo(() => {
//         return modules.reduce((acc, moduleItem) => { acc[moduleItem.id] = moduleItem; return acc; }, {});
//     }, [modules]);

//     const initializeEditStateForRole = (roleId, currentEditState) => {
//         const rolePerms = rolePermissions.find(r => r.role_id === roleId)?.permissions || [];
//         const editingData = {};

//         rolePerms.forEach(perm => {
//             editingData[perm.module_id] = {
//                 allow_view: perm.allow_view, allow_create: perm.allow_create,
//                 allow_edit: perm.allow_edit, allow_delete: perm.allow_delete
//             };
//         });

//         modules.forEach(m => {
//             if (!editingData[m.id]) editingData[m.id] = { allow_view: false, allow_create: false, allow_edit: false, allow_delete: false };
//         });

//         return { ...currentEditState, [roleId]: editingData };
//     };

//     const handleGlobalToggle = () => {
//         if (isExpanded) {
//             setExpandedRoles({});
//             setIsExpanded(false);
//         } else {
//             const newExpanded = {};
//             let newEditState = { ...editingPermissions };
//             rolePermissions.forEach(role => {
//                 newExpanded[role.role_id] = true;
//                 if (!newEditState[role.role_id]) newEditState = initializeEditStateForRole(role.role_id, newEditState);
//             });
//             setExpandedRoles(newExpanded);
//             setEditingPermissions(newEditState);
//             setIsExpanded(true);
//         }
//     };

//     const handleRowToggle = (roleId) => {
//         setExpandedRoles(prev => {
//             const isCurrentlyOpen = !!prev[roleId];
//             const next = { ...prev, [roleId]: !isCurrentlyOpen };
//             setIsExpanded(Object.values(next).every(v => v));
//             if (!isCurrentlyOpen) setEditingPermissions(cur => cur[roleId] ? cur : initializeEditStateForRole(roleId, cur));
//             return next;
//         });
//     };

//     // --- UPDATED SMART TOGGLE LOGIC ---
//     const handleInlineToggle = (roleId, moduleId, field) => {
//         setEditingPermissions(prev => {
//             const roleData = prev[roleId] ? { ...prev[roleId] } : {};
            
//             // Ensure all modules exist in state
//             modules.forEach(m => {
//                 if (!roleData[m.id]) roleData[m.id] = { allow_view: false, allow_create: false, allow_edit: false, allow_delete: false };
//             });

//             const currentVal = roleData[moduleId][field];
//             const newValue = !currentVal;
//             const targetModule = modules.find(m => String(m.id) === String(moduleId));
//             const isParentModule = (!targetModule?.parent_module || String(targetModule?.parent_module) === "0");

//             const applyPermission = (mId, f, val) => {
//                 let p = { ...roleData[mId] };
//                 p[f] = val;
//                 if (f === 'allow_view' && val === false) { p.allow_create = false; p.allow_edit = false; }
//                 if ((f === 'allow_create' || f === 'allow_edit') && val === true) p.allow_view = true;
//                 roleData[mId] = p;
//             };

//             // 1. Target Toggle
//             applyPermission(moduleId, field, newValue);

//             // 2. Downward Sync (Parent to Children)
//             if (isParentModule) {
//                 modules.filter(m => String(m.parent_module) === String(moduleId)).forEach(c => applyPermission(c.id, field, newValue));
//             }

//             // 3. Upward Sync (Children to Parent) - FIXED: Use .some() instead of .every()
//             const parentModules = modules.filter(m => !m.parent_module || String(m.parent_module) === "0");
//             parentModules.forEach(parentMod => {
//                 const pId = parentMod.id;
//                 const childIds = modules.filter(m => String(m.parent_module) === String(pId)).map(m => m.id);
                
//                 if (childIds.length > 0 && roleData[pId]) {
//                     let pPerm = { ...roleData[pId] };
                    
//                     // SMART VIEW: If ANY child is checked, Parent stays checked
//                     pPerm.allow_view = childIds.some(cId => roleData[cId].allow_view === true);
                    
//                     // For Create/Edit: Logic remains same (or you can use .some() if you want same behavior)
//                     ['allow_create', 'allow_edit'].forEach(f => {
//                         pPerm[f] = childIds.some(cId => roleData[cId][f] === true);
//                     });
                    
//                     if (!pPerm.allow_view) { pPerm.allow_create = false; pPerm.allow_edit = false; }
//                     roleData[pId] = pPerm;
//                 }
//             });

//             setHasUnsavedChanges(true);
//             return { ...prev, [roleId]: roleData };
//         });
//     };

//     const handleSelectAllToggle = (roleId, permissionType) => {
//         const rolePerms = rolePermissions.find(r => r.role_id === roleId)?.permissions || [];
//         const currentRoleEditState = editingPermissions[roleId] || {};

//         const allChecked = rolePerms.length > 0 && rolePerms.every(perm => currentRoleEditState[perm.module_id]?.[permissionType] === true);
//         const newValue = !allChecked;

//         setEditingPermissions(prev => {
//             const roleData = prev[roleId] ? { ...prev[roleId] } : {};
//             rolePerms.forEach(perm => {
//                 let m = { ...(roleData[perm.module_id] || { allow_view: false, allow_create: false, allow_edit: false, allow_delete: false }), [permissionType]: newValue };
//                 if (permissionType === 'allow_view' && !newValue) { m.allow_create = false; m.allow_edit = false; }
//                 if ((permissionType === 'allow_create' || permissionType === 'allow_edit') && newValue) m.allow_view = true;
//                 roleData[perm.module_id] = m;
//             });
//             setHasUnsavedChanges(true);
//             return { ...prev, [roleId]: roleData };
//         });
//     };

//     const handleGlobalSave = async () => {
//         setLoading(true);
//         try {
//             const roleIds = Object.keys(editingPermissions);
//             await Promise.all(roleIds.map(id => saveRolePermissions(id)));
//             PubSub.publish("RECORD_SAVED_TOAST", { message: "All changes saved!" });
//             setEditingPermissions({});
//             setHasUnsavedChanges(false);
//             setRefreshKey(k => k + 1);
//         } catch (err) {
//             PubSub.publish("RECORD_ERROR_TOAST", { message: "Save failed" });
//         } finally { setLoading(false); }
//     };

//     const saveRolePermissions = async (roleId) => {
//         const roleData = editingPermissions[roleId];
//         const permissionsToSave = Object.keys(roleData).map(mId => ({ module_id: mId, ...roleData[mId] }));
//         const api = new DataApi("permissions/role");
//         await api.update({ role_id: roleId === 'null' ? null : roleId, permissions: permissionsToSave }, roleId);
//     };

//     const confirmDelete = async () => {
//         const api = new DataApi("permissions");
//         const toDelete = permissions.filter(p => (p.role_id || 'null') === roleToDelete.id);
//         await Promise.all(toDelete.map(p => p.id && api.delete(p.id)));
//         setShowConfirmModal(false);
//         setRefreshKey(k => k + 1);
//     };

//     if (loading && !permissions.length) return <div className="text-center py-5"><span className="loader"></span></div>;

//     return (
//         <div className="container-fluid permission-page">
//             <CustomHeader rolePermissionsLength={rolePermissions.length} isExpanded={isExpanded} handleGlobalToggle={handleGlobalToggle} onAddNewRole={() => { setEditingRole(null); setShowAddModal(true); }} />
//             <div>
//                 {rolePermissions.map(role => (
//                     <RoleAccordion key={role.role_id} role={role} expandedRoles={expandedRoles} handleRowToggle={handleRowToggle} permissions={permissions} modules={modules} moduleMap={moduleMap} editingPermissions={editingPermissions} handleSelectAllToggle={handleSelectAllToggle} handleInlineToggle={handleInlineToggle} />
//                 ))}
//             </div>
//             <AddPermissionModal show={showAddModal} handleClose={() => setShowAddModal(false)} onSave={async (d) => { await saveRolePermissions(d.role_id); setShowAddModal(false); setRefreshKey(k => k + 1); }} />
//             <ConfirmationModal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} onConfirm={confirmDelete} title="Delete" message="Confirm delete?" />
//             <div className="mx-3 pb-4 d-flex justify-content-end">
//                 <Button onClick={handleGlobalSave} disabled={!hasUnsavedChanges} className="btn-paper px-3 py-2 fw-bold shadow-sm" style={{ background: hasUnsavedChanges ? '#0d6efd' : '#6c757d', color: '#fff', border: 'none' }}>
//                     <i className="fa-solid fa-paper-plane me-2"></i> Save 
//                 </Button>
//             </div>
//         </div>
//     );
// };

// export default Permission;

// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import AddPermissionModal from './addPermissionmodule';
// import DataApi from '../../api/dataApi';
// import { AuthHelper } from '../../utils/authHelper';
// import PubSub from "pubsub-js";
// import { Button, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
// import ConfirmationModal from "../common/ConfirmationModal";

// // --- CHILD COMPONENTS ---
// const TooltipButton = ({ title, children }) => (
//     <OverlayTrigger placement="top" overlay={<Tooltip>{title}</Tooltip>}>
//         <span className="d-inline-block">{children}</span>
//     </OverlayTrigger>
// );

// const CustomHeader = ({ rolePermissionsLength, isExpanded, handleGlobalToggle, onAddNewRole }) => (
//     <div className="d-flex justify-content-between align-items-center p-2 my-4 mx-3"
//         style={{ color: "var(--primary-color)", background: "var(--primary-background-color)", borderRadius: "10px" }}>
//         <h5 className="fw-bold mb-1">
//             <i className="fa-solid fa-user-shield me-2 fs-6"></i> Role Permissions ({rolePermissionsLength})
//         </h5>
//         <div className="d-flex align-items-center gap-3">
//             <TooltipButton title={isExpanded ? "Collapse All" : "Expand All to Edit"}>
//                 <Form.Check type="switch" id="expand-collapse-toggle" checked={isExpanded} onChange={handleGlobalToggle}
//                     style={{ transform: "scale(1.8)", transformOrigin: "left center", cursor: "pointer", marginRight: "10px" }} />
//             </TooltipButton>
//             <TooltipButton title="Add New Role">
//                 <Button className="custom-btn-table-header p-2" onClick={onAddNewRole}>
//                     <i className="fa-solid fa-plus fs-6 my-1"></i>
//                 </Button>
//             </TooltipButton>
//         </div>
//     </div>
// );

// const PermissionCell = ({ roleId, moduleId, field, value, editingPermissions, handleInlineToggle }) => {
//     let checked = value || false;
//     if (editingPermissions[roleId] && editingPermissions[roleId][moduleId]) {
//         checked = editingPermissions[roleId][moduleId][field];
//     }
//     return (
//         <div className="d-inline-block cursor-pointer" onClick={() => handleInlineToggle(roleId, moduleId, field)} title={checked ? "Enabled" : "Disabled"}>
//             {checked ? (
//                 <i className="fa-solid fa-check-square text-primary fs-5"></i>
//             ) : (
//                 <i className="fa-regular fa-square text-secondary fs-5" style={{ opacity: 0.6 }}></i>
//             )}
//         </div>
//     );
// };

// const SelectAllHeader = ({ roleId, permissionType, label, editingPermissions, rolePermissions, handleSelectAllToggle }) => {
//     let isChecked = false;
//     if (editingPermissions[roleId]) {
//         const roleData = editingPermissions[roleId];
//         const roleModules = rolePermissions || [];
//         if (roleModules.length > 0) {
//             isChecked = roleModules.every(m => roleData[m.module_id]?.[permissionType] === true);
//         }
//     }
//     return (
//         <th width="17.5%" className="text-center">
//             <div className="d-flex flex-column align-items-center justify-content-center">
//                 <div className="cursor-pointer" onClick={() => handleSelectAllToggle(roleId, permissionType)} title={isChecked ? "Deselect All" : "Select All"}>
//                     {isChecked ? <i className="fa-solid fa-check-square text-primary fs-5"></i> : <i className="fa-regular fa-square text-secondary fs-5"></i>}
//                 </div>
//                 <span className="fw-semibold mb-1">{label}</span>
//             </div>
//         </th>
//     );
// };

// // --- ROLE ACCORDION ---
// const RoleAccordion = ({ role, expandedRoles, handleRowToggle, modules, moduleMap, editingPermissions, handleSelectAllToggle, handleInlineToggle }) => {
//     const isOpen = expandedRoles[role.role_id] || false;
//     const [expandedParents, setExpandedParents] = useState({});

//     // FULLY DYNAMIC TREE WITH VIRTUAL CHILDREN FOR PURCHASES
//     const moduleTree = useMemo(() => {
//         const parentModules = [];
//         const childrenByParent = {};
//         const roleModuleIds = new Set(role.permissions.map(p => String(p.module_id)));

//         // 1. Identify shared modules that need to be duplicated under Purchases
//         const sharedModuleNames = ["Authors", "Categories", "Publisher"];
//         const sharedPerms = role.permissions.filter(p => sharedModuleNames.includes(p.module_name));

//         role.permissions.forEach(perm => {
//             const mId = String(perm.module_id);
//             const moduleInfo = moduleMap[mId];
//             const pId = (moduleInfo?.parent_module && String(moduleInfo.parent_module) !== "0") ? String(moduleInfo.parent_module) : null;

//             if (pId && roleModuleIds.has(pId)) {
//                 childrenByParent[pId] = childrenByParent[pId] || [];
//                 childrenByParent[pId].push(perm);
//             } else {
//                 parentModules.push(perm);
//             }
//         });

//         // 2. Inject shared modules into Purchases
//         parentModules.forEach(p => {
//             if (p.module_name === "Purchases") {
//                 const pId = String(p.module_id);
//                 childrenByParent[pId] = childrenByParent[pId] || [];
                
//                 sharedPerms.forEach(shared => {
//                     // Check to avoid accidental duplicates
//                     if (!childrenByParent[pId].find(c => String(c.module_id) === String(shared.module_id))) {
//                         childrenByParent[pId].push(shared);
//                     }
//                 });
//             }
//         });

//         const sortByName = (a, b) => (a.module_name || "").localeCompare(b.module_name || "");
//         parentModules.sort(sortByName);
//         Object.values(childrenByParent).forEach(arr => arr.sort(sortByName));

//         return { parentModules, childrenByParent };
//     }, [role.permissions, moduleMap]);

//     const toggleParent = (moduleId) => setExpandedParents(prev => ({ ...prev, [moduleId]: !prev[moduleId] }));

//     return (
//         <div className="card border shadow-sm mx-3">
//             <div className="card-header p-3 d-flex justify-content-between align-items-center bg-light" onClick={() => handleRowToggle(role.role_id)} style={{ cursor: 'pointer' }}>
//                 <h6 className="mb-0 fw-bold"><i className="fa-solid fa-user-tag me-2 text-primary"></i>{role.role_name}</h6>
//                 <i className={`fa-solid ${isOpen ? "fa-chevron-down" : "fa-chevron-up"}`}></i>
//             </div>
//             {isOpen && (
//                 <div className="card-body p-0">
//                     <table className="table table-hover mb-0">
//                         <thead className="table-light">
//                             <tr>
//                                 <th width="35%" className="ps-4">Module Name</th>
//                                 <SelectAllHeader roleId={role.role_id} permissionType="allow_view" label="View" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                                 <SelectAllHeader roleId={role.role_id} permissionType="allow_create" label="Create" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                                 <SelectAllHeader roleId={role.role_id} permissionType="allow_edit" label="Edit" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {moduleTree.parentModules.map(parentPerm => {
//                                 const pId = String(parentPerm.module_id);
//                                 const children = moduleTree.childrenByParent[pId] || [];
//                                 const isExpanded = expandedParents[pId] || false;
//                                 return (
//                                     <React.Fragment key={`${role.role_id}-${pId}`}>
//                                         <tr style={{ backgroundColor: children.length > 0 ? '#f8f9fa' : 'transparent' }}>
//                                             <td className="ps-4 py-2" onClick={() => children.length > 0 && toggleParent(pId)} style={{ cursor: children.length > 0 ? 'pointer' : 'default' }}>
//                                                 {children.length > 0 && <i className={`fa-solid ${isExpanded ? "fa-minus" : "fa-plus"} me-2 text-primary`} style={{fontSize: '0.8rem'}} />}
//                                                 <span className={children.length > 0 ? "fw-bold" : ""}>{parentPerm.module_name}</span>
//                                             </td>
//                                             <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_view" value={parentPerm.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                             <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_create" value={parentPerm.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                             <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_edit" value={parentPerm.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                         </tr>
//                                         {isExpanded && children.map(child => (
//                                             <tr key={`${role.role_id}-${pId}-${child.module_id}`}> {/* Added pId to key to prevent duplicate React keys */}
//                                                 <td className="ps-5 py-2"><span className="text-muted ms-3 border-start ps-3">{child.module_name}</span></td>
//                                                 <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_view" value={child.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                                 <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_create" value={child.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                                 <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_edit" value={child.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
//                                             </tr>
//                                         ))}
//                                     </React.Fragment>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             )}
//         </div>
//     );
// };

// const Permission = () => {
//     const [permissions, setPermissions] = useState([]);
//     const [roles, setRoles] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [modules, setModules] = useState([]);
//     const [editingPermissions, setEditingPermissions] = useState({});
//     const [expandedRoles, setExpandedRoles] = useState({});
//     const [isExpanded, setIsExpanded] = useState(false);
//     const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//     const [refreshKey, setRefreshKey] = useState(0);
//     const [showAddModal, setShowAddModal] = useState(false);

//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             const [pRes, rRes, mRes] = await Promise.all([
//                 new DataApi("permissions").fetchAll(),
//                 new DataApi("user-role").fetchAll(),
//                 new DataApi("module").fetchAll()
//             ]);
//             setPermissions(pRes?.data?.data || pRes?.data || []);
//             setRoles(Array.isArray(rRes?.data) ? rRes.data : []);
            
//             // Map modules and ensure parent_module IDs are strings for clean comparison
//             const rawModules = (mRes?.data?.records || []).map(m => ({
//                 ...m,
//                 parent_module: (m.parent_module && String(m.parent_module) !== "0") ? String(m.parent_module) : null
//             }));
//             setModules(rawModules);
//         } catch (e) { console.error(e); }
//         setLoading(false);
//     }, []);

//     useEffect(() => { fetchData(); }, [fetchData, refreshKey]);

//     const moduleMap = useMemo(() => modules.reduce((acc, m) => { acc[m.id] = m; return acc; }, {}), [modules]);

//     const rolePermissions = useMemo(() => {
//         const grouped = {};
//         const roleMap = roles.reduce((acc, r) => { acc[r.id] = r; return acc; }, {});
//         const permByRole = permissions.reduce((acc, p) => {
//             const rid = p.role_id || 'null';
//             if (!acc[rid]) acc[rid] = [];
//             acc[rid].push(p);
//             return acc;
//         }, {});
        
//         const roleIds = new Set([...Object.keys(permByRole), ...roles.map(r => r.id)]);
//         roleIds.forEach(rid => {
//             const roleInfo = roleMap[rid];
//             if (roleInfo?.role_name?.toUpperCase() === "SYSTEM ADMIN") return;
//             const pMap = (permByRole[rid] || []).reduce((acc, p) => { acc[p.module_id] = p; return acc; }, {});
//             const list = modules.map(m => ({
//                 module_id: m.id, module_name: m.name, parent_module: m.parent_module,
//                 allow_view: !!pMap[m.id]?.allow_view, allow_create: !!pMap[m.id]?.allow_create, allow_edit: !!pMap[m.id]?.allow_edit
//             }));
//             grouped[rid] = { role_id: rid, role_name: roleInfo?.role_name || `Role ${rid}`, permissions: list };
//         });
//         return Object.values(grouped);
//     }, [permissions, roles, modules]);

//     const initializeRoleState = (rid, current) => {
//         const roleData = {};
//         modules.forEach(m => {
//             const existing = permissions.find(p => String(p.role_id) === String(rid) && String(p.module_id) === String(m.id));
//             roleData[m.id] = { allow_view: !!existing?.allow_view, allow_create: !!existing?.allow_create, allow_edit: !!existing?.allow_edit };
//         });
//         return { ...current, [rid]: roleData };
//     };

//     const handleInlineToggle = (roleId, moduleId, field) => {
//         setEditingPermissions(prev => {
//             let roleData = prev[roleId] ? { ...prev[roleId] } : initializeRoleState(roleId, prev)[roleId];
//             const newValue = !roleData[moduleId][field];

//             const applyRules = (mId, f, val) => {
//                 let p = { ...roleData[mId], [f]: val };
//                 // RULE 1: If Create/Edit checked -> View must be true
//                 if ((f === 'allow_create' || f === 'allow_edit') && val === true) p.allow_view = true;
//                 // RULE 2: If View checked -> Auto-check Create & Edit
//                 if (f === 'allow_view' && val === true) { p.allow_create = true; p.allow_edit = true; }
//                 // RULE 3: If View unchecked -> Uncheck all
//                 if (f === 'allow_view' && val === false) { p.allow_create = false; p.allow_edit = false; }
//                 roleData[mId] = p;
//             };

//             applyRules(moduleId, field, newValue);

//             // Downward Sync (Parent to Children)
//             const isParent = !moduleMap[moduleId]?.parent_module || String(moduleMap[moduleId]?.parent_module) === "0";
//             if (isParent) {
//                 modules.filter(m => String(m.parent_module) === String(moduleId)).forEach(c => applyRules(c.id, field, newValue));
//             }

//             // Upward Sync (Smart Parent Check)
//             modules.filter(m => !m.parent_module || String(m.parent_module) === "0").forEach(pMod => {
//                 const cIds = modules.filter(m => String(m.parent_module) === String(pMod.id)).map(m => m.id);
//                 if (cIds.length > 0 && roleData[pMod.id]) {
//                     roleData[pMod.id].allow_view = cIds.some(cid => roleData[cid].allow_view);
//                     roleData[pMod.id].allow_create = cIds.some(cid => roleData[cid].allow_create);
//                     roleData[pMod.id].allow_edit = cIds.some(cid => roleData[cid].allow_edit);
//                 }
//             });

//             setHasUnsavedChanges(true);
//             return { ...prev, [roleId]: roleData };
//         });
//     };

//     const handleSelectAllToggle = (roleId, field) => {
//         const role = rolePermissions.find(r => r.role_id === roleId);
//         const roleData = editingPermissions[roleId] || initializeRoleState(roleId, {})[roleId];
//         const allChecked = role.permissions.every(p => roleData[p.module_id][field]);
//         const newValue = !allChecked;

//         setEditingPermissions(prev => {
//             let nextRoleData = { ...roleData };
//             role.permissions.forEach(p => {
//                 let m = { ...nextRoleData[p.module_id], [field]: newValue };
//                 if (field === 'allow_view' && newValue === true) { m.allow_create = true; m.allow_edit = true; }
//                 if (field === 'allow_view' && newValue === false) { m.allow_create = false; m.allow_edit = false; }
//                 if ((field === 'allow_create' || field === 'allow_edit') && newValue === true) m.allow_view = true;
//                 nextRoleData[p.module_id] = m;
//             });
//             setHasUnsavedChanges(true);
//             return { ...prev, [roleId]: nextRoleData };
//         });
//     };

//     const handleGlobalSave = async () => {
//         setLoading(true);
//         try {
//             const api = new DataApi("permissions/role");
//             await Promise.all(Object.keys(editingPermissions).map(rid => 
//                 api.update({ role_id: rid === 'null' ? null : rid, permissions: Object.keys(editingPermissions[rid]).map(mid => ({ module_id: mid, ...editingPermissions[rid][mid] })) }, rid)
//             ));
//             PubSub.publish("RECORD_SAVED_TOAST", { message: "Saved Successfully" });
//             setHasUnsavedChanges(false); setEditingPermissions({}); setRefreshKey(k => k + 1);
//         } catch (e) { PubSub.publish("RECORD_ERROR_TOAST", { message: "Save failed" }); }
//         setLoading(false);
//     };

//     if (loading && !modules.length) return <div className="text-center py-5">Loading...</div>;

//     return (
//         <div className="container-fluid permission-page">
//             <CustomHeader rolePermissionsLength={rolePermissions.length} isExpanded={isExpanded} handleGlobalToggle={() => setIsExpanded(!isExpanded)} onAddNewRole={() => setShowAddModal(true)} />
//             <div>
//                 {rolePermissions.map(role => (
//                     <RoleAccordion key={role.role_id} role={role} 
//                         expandedRoles={isExpanded ? rolePermissions.reduce((acc, r) => ({ ...acc, [r.role_id]: true }), {}) : expandedRoles}
//                         handleRowToggle={(id) => setExpandedRoles(p => ({ ...p, [id]: !p[id] }))} 
//                         modules={modules} moduleMap={moduleMap} editingPermissions={editingPermissions} 
//                         handleSelectAllToggle={handleSelectAllToggle} handleInlineToggle={handleInlineToggle} 
//                     />
//                 ))}
//             </div>
//             <div className="mx-3 pb-4 d-flex justify-content-end">
//                 <Button onClick={handleGlobalSave} disabled={!hasUnsavedChanges} className="btn-paper shadow-sm px-3 py-2 fw-bold" style={{ background: hasUnsavedChanges ? '#0d6efd' : '#6c757d', color: '#fff', border: 'none' }}>
//                     <i className="fa-solid fa-paper-plane me-2"></i> Save Changes
//                 </Button>
//             </div>
//             <AddPermissionModal show={showAddModal} handleClose={() => setShowAddModal(false)} onSave={() => setRefreshKey(k => k + 1)} />
//         </div>
//     );
// };

// export default Permission;


import React, { useState, useEffect, useMemo, useCallback } from 'react';
import AddPermissionModal from './addPermissionmodule';
import DataApi from '../../api/dataApi';
import { AuthHelper } from '../../utils/authHelper';
import PubSub from "pubsub-js";
import { Button, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import ConfirmationModal from "../common/ConfirmationModal";

// --- CHILD COMPONENTS ---
const TooltipButton = ({ title, children }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{title}</Tooltip>}>
        <span className="d-inline-block">{children}</span>
    </OverlayTrigger>
);

const CustomHeader = ({ rolePermissionsLength, isExpanded, handleGlobalToggle, onAddNewRole }) => (
    <div className="d-flex justify-content-between align-items-center p-2 my-4 mx-3"
        style={{ color: "var(--primary-color)", background: "var(--primary-background-color)", borderRadius: "10px" }}>
        <h5 className="fw-bold mb-1">
            <i className="fa-solid fa-user-shield me-2 fs-6"></i> Role Permissions ({rolePermissionsLength})
        </h5>
        <div className="d-flex align-items-center gap-3">
            <TooltipButton title={isExpanded ? "Collapse All" : "Expand All to Edit"}>
                <Form.Check type="switch" id="expand-collapse-toggle" checked={isExpanded} onChange={handleGlobalToggle}
                    style={{ transform: "scale(1.8)", transformOrigin: "left center", cursor: "pointer", marginRight: "10px" }} />
            </TooltipButton>
            <TooltipButton title="Add New Role">
                <Button className="custom-btn-table-header p-2" onClick={onAddNewRole}>
                    <i className="fa-solid fa-plus fs-6 my-1"></i>
                </Button>
            </TooltipButton>
        </div>
    </div>
);

const PermissionCell = ({ roleId, moduleId, field, value, editingPermissions, handleInlineToggle }) => {
    let checked = value || false;
    if (editingPermissions[roleId] && editingPermissions[roleId][moduleId]) {
        checked = editingPermissions[roleId][moduleId][field];
    }
    return (
        <div className="d-inline-block cursor-pointer" onClick={() => handleInlineToggle(roleId, moduleId, field)} title={checked ? "Enabled" : "Disabled"}>
            {checked ? (
                <i className="fa-solid fa-check-square text-primary fs-5"></i>
            ) : (
                <i className="fa-regular fa-square text-secondary fs-5" style={{ opacity: 0.6 }}></i>
            )}
        </div>
    );
};

const SelectAllHeader = ({ roleId, permissionType, label, editingPermissions, rolePermissions, handleSelectAllToggle }) => {
    let isChecked = false;
    if (editingPermissions[roleId]) {
        const roleData = editingPermissions[roleId];
        const roleModules = rolePermissions || [];
        if (roleModules.length > 0) {
            isChecked = roleModules.every(m => roleData[m.module_id]?.[permissionType] === true);
        }
    }
    return (
        <th width="17.5%" className="text-center">
            <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="cursor-pointer" onClick={() => handleSelectAllToggle(roleId, permissionType)} title={isChecked ? "Deselect All" : "Select All"}>
                    {isChecked ? <i className="fa-solid fa-check-square text-primary fs-5"></i> : <i className="fa-regular fa-square text-secondary fs-5"></i>}
                </div>
                <span className="fw-semibold mb-1">{label}</span>
            </div>
        </th>
    );
};

// --- ROLE ACCORDION ---
const RoleAccordion = ({ role, expandedRoles, handleRowToggle, modules, moduleMap, editingPermissions, handleSelectAllToggle, handleInlineToggle }) => {
    const isOpen = expandedRoles[role.role_id] || false;
    const [expandedParents, setExpandedParents] = useState({});

    // DYNAMIC TREE: Shared modules ko dono parents (Books & Purchases) mein inject karega
    const moduleTree = useMemo(() => {
        const parentModules = [];
        const childrenByParent = {};
        
        // 1. Target Parents aur Shared Children identify karein
        const booksModule = role.permissions.find(p => p.module_name === "Books");
        const purchasesModule = role.permissions.find(p => p.module_name === "Purchases");
        
        // In names ko check karein ke ye aapke DB names se match karte ho
        const sharedModuleNames = ["Authors", "Categories", "Publisher"];
        const sharedPerms = role.permissions.filter(p => sharedModuleNames.includes(p.module_name));

        // 2. Standard Hierarchy Build karein
        role.permissions.forEach(perm => {
            const mId = String(perm.module_id);
            const moduleInfo = moduleMap[mId];
            const pId = (moduleInfo?.parent_module && String(moduleInfo.parent_module) !== "0") ? String(moduleInfo.parent_module) : null;

            if (pId) {
                childrenByParent[pId] = childrenByParent[pId] || [];
                if (!childrenByParent[pId].find(c => c.module_id === perm.module_id)) {
                    childrenByParent[pId].push(perm);
                }
            } else {
                if (!parentModules.find(p => p.module_id === perm.module_id)) {
                    parentModules.push(perm);
                }
            }
        });

        // 3. LOGIC: Books aur Purchases dono mein shared modules inject karna
        const forceInject = (targetParent) => {
            if (targetParent) {
                const targetId = String(targetParent.module_id);
                childrenByParent[targetId] = childrenByParent[targetId] || [];
                
                sharedPerms.forEach(shared => {
                    const alreadyExists = childrenByParent[targetId].find(c => String(c.module_id) === String(shared.module_id));
                    if (!alreadyExists) {
                        childrenByParent[targetId].push(shared);
                    }
                });
            }
        };

        forceInject(booksModule);
        forceInject(purchasesModule);

        // Sorting taaki UI clean dikhe
        const sortByName = (a, b) => (a.module_name || "").localeCompare(b.module_name || "");
        parentModules.sort(sortByName);
        Object.values(childrenByParent).forEach(arr => arr.sort(sortByName));

        return { parentModules, childrenByParent };
    }, [role.permissions, moduleMap]);

    const toggleParent = (moduleId) => setExpandedParents(prev => ({ ...prev, [moduleId]: !prev[moduleId] }));

    return (
        <div className="card border shadow-sm mx-3">
            <div className="card-header p-3 d-flex justify-content-between align-items-center bg-light" 
                 onClick={() => handleRowToggle(role.role_id)} style={{ cursor: 'pointer' }}>
                <h6 className="mb-0 fw-bold">
                    <i className="fa-solid fa-user-tag me-2 text-primary"></i>{role.role_name}
                </h6>
                <i className={`fa-solid ${isOpen ? "fa-chevron-down" : "fa-chevron-up"}`}></i>
            </div>
            
            {isOpen && (
                <div className="card-body p-0">
                    <table className="table table-hover mb-0">
                        <thead className="table-light">
                            <tr>
                                <th width="35%" className="ps-4">Module Name</th>
                                <SelectAllHeader roleId={role.role_id} permissionType="allow_view" label="View" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
                                <SelectAllHeader roleId={role.role_id} permissionType="allow_create" label="Create" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
                                <SelectAllHeader roleId={role.role_id} permissionType="allow_edit" label="Edit" editingPermissions={editingPermissions} rolePermissions={role.permissions} handleSelectAllToggle={handleSelectAllToggle} />
                            </tr>
                        </thead>
                        <tbody>
                            {moduleTree.parentModules.map(parentPerm => {
                                const pId = String(parentPerm.module_id);
                                const children = moduleTree.childrenByParent[pId] || [];
                                const isExpanded = expandedParents[pId] || false;

                                return (
                                    <React.Fragment key={`role-${role.role_id}-p-${pId}`}>
                                        {/* Parent Row */}
                                        <tr style={{ backgroundColor: children.length > 0 ? '#f8f9fa' : 'transparent' }}>
                                            <td className="ps-4 py-2" onClick={() => children.length > 0 && toggleParent(pId)} style={{ cursor: children.length > 0 ? 'pointer' : 'default' }}>
                                                {children.length > 0 && (
                                                    <i className={`fa-solid ${isExpanded ? "fa-minus" : "fa-plus"} me-2 text-primary`} style={{fontSize: '0.8rem'}} />
                                                )}
                                                <span className={children.length > 0 ? "fw-bold" : ""}>{parentPerm.module_name}</span>
                                            </td>
                                            <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_view" value={parentPerm.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
                                            <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_create" value={parentPerm.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
                                            <td className="text-center"><PermissionCell roleId={role.role_id} moduleId={pId} field="allow_edit" value={parentPerm.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} /></td>
                                        </tr>

                                        {/* Child Rows (Authors, Publisher, etc.) */}
                                        {isExpanded && children.map(child => (
                                            <tr key={`role-${role.role_id}-parent-${pId}-child-${child.module_id}`}>
                                                <td className="ps-5 py-2">
                                                    <span className="text-muted ms-3 border-start ps-3">{child.module_name}</span>
                                                </td>
                                                <td className="text-center">
                                                    <PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_view" value={child.allow_view} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
                                                </td>
                                                <td className="text-center">
                                                    <PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_create" value={child.allow_create} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
                                                </td>
                                                <td className="text-center">
                                                    <PermissionCell roleId={role.role_id} moduleId={child.module_id} field="allow_edit" value={child.allow_edit} editingPermissions={editingPermissions} handleInlineToggle={handleInlineToggle} />
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const Permission = () => {
    const [permissions, setPermissions] = useState([]);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modules, setModules] = useState([]);
    const [editingPermissions, setEditingPermissions] = useState({});
    const [expandedRoles, setExpandedRoles] = useState({});
    const [isExpanded, setIsExpanded] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [showAddModal, setShowAddModal] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const [pRes, rRes, mRes] = await Promise.all([
                new DataApi("permissions").fetchAll(),
                new DataApi("user-role").fetchAll(),
                new DataApi("module").fetchAll()
            ]);
            setPermissions(pRes?.data?.data || pRes?.data || []);
            setRoles(Array.isArray(rRes?.data) ? rRes.data : []);
            
            const rawModules = (mRes?.data?.records || []).map(m => ({
                ...m,
                parent_module: (m.parent_module && String(m.parent_module) !== "0") ? String(m.parent_module) : null
            }));
            setModules(rawModules);
        } catch (e) { console.error(e); }
        setLoading(false);
    }, []);

    useEffect(() => { fetchData(); }, [fetchData, refreshKey]);

    const moduleMap = useMemo(() => modules.reduce((acc, m) => { acc[m.id] = m; return acc; }, {}), [modules]);

    const rolePermissions = useMemo(() => {
        const grouped = {};
        
        const permByRole = permissions.reduce((acc, p) => {
            const rid = p.role_id || 'null';
            if (!acc[rid]) acc[rid] = [];
            acc[rid].push(p);
            return acc;
        }, {});
        
        // ONLY loop through ACTIVE roles from the DB, ignoring deleted orphan roles
        roles.forEach(role => {
            const rid = role.id;
            const roleName = (role.role_name || "").toUpperCase();

            // FILTER OUT ADMIN ROLES
            if (roleName === "SYSTEM ADMIN" || roleName === "SUPER ADMIN" || roleName === "ADMIN") {
                return;
            }

            const pMap = (permByRole[rid] || []).reduce((acc, p) => { acc[p.module_id] = p; return acc; }, {});
            
            const list = modules.map(m => ({
                module_id: m.id, 
                module_name: m.name, 
                parent_module: m.parent_module,
                allow_view: !!pMap[m.id]?.allow_view, 
                allow_create: !!pMap[m.id]?.allow_create, 
                allow_edit: !!pMap[m.id]?.allow_edit
            }));

            grouped[rid] = { 
                role_id: rid, 
                role_name: role.role_name, 
                permissions: list 
            };
        });
        
        return Object.values(grouped);
    }, [permissions, roles, modules]);

    const initializeRoleState = (rid, current) => {
        const roleData = {};
        modules.forEach(m => {
            const existing = permissions.find(p => String(p.role_id) === String(rid) && String(p.module_id) === String(m.id));
            roleData[m.id] = { allow_view: !!existing?.allow_view, allow_create: !!existing?.allow_create, allow_edit: !!existing?.allow_edit };
        });
        return { ...current, [rid]: roleData };
    };

    const handleInlineToggle = (roleId, moduleId, field) => {
        setEditingPermissions(prev => {
            let roleData = prev[roleId] ? { ...prev[roleId] } : initializeRoleState(roleId, prev)[roleId];
            const newValue = !roleData[moduleId][field];

            const applyRules = (mId, f, val) => {
                let p = { ...roleData[mId], [f]: val };
                if ((f === 'allow_create' || f === 'allow_edit') && val === true) p.allow_view = true;
                if (f === 'allow_view' && val === true) { p.allow_create = true; p.allow_edit = true; }
                if (f === 'allow_view' && val === false) { p.allow_create = false; p.allow_edit = false; }
                roleData[mId] = p;
            };

            applyRules(moduleId, field, newValue);

            const isParent = !moduleMap[moduleId]?.parent_module || String(moduleMap[moduleId]?.parent_module) === "0";
            if (isParent) {
                modules.filter(m => String(m.parent_module) === String(moduleId)).forEach(c => applyRules(c.id, field, newValue));
            }

            modules.filter(m => !m.parent_module || String(m.parent_module) === "0").forEach(pMod => {
                const cIds = modules.filter(m => String(m.parent_module) === String(pMod.id)).map(m => m.id);
                if (cIds.length > 0 && roleData[pMod.id]) {
                    roleData[pMod.id].allow_view = cIds.some(cid => roleData[cid].allow_view);
                    roleData[pMod.id].allow_create = cIds.some(cid => roleData[cid].allow_create);
                    roleData[pMod.id].allow_edit = cIds.some(cid => roleData[cid].allow_edit);
                }
            });

            setHasUnsavedChanges(true);
            return { ...prev, [roleId]: roleData };
        });
    };

    const handleSelectAllToggle = (roleId, field) => {
        const role = rolePermissions.find(r => r.role_id === roleId);
        const roleData = editingPermissions[roleId] || initializeRoleState(roleId, {})[roleId];
        const allChecked = role.permissions.every(p => roleData[p.module_id][field]);
        const newValue = !allChecked;

        setEditingPermissions(prev => {
            let nextRoleData = { ...roleData };
            role.permissions.forEach(p => {
                let m = { ...nextRoleData[p.module_id], [field]: newValue };
                if (field === 'allow_view' && newValue === true) { m.allow_create = true; m.allow_edit = true; }
                if (field === 'allow_view' && newValue === false) { m.allow_create = false; m.allow_edit = false; }
                if ((field === 'allow_create' || field === 'allow_edit') && newValue === true) m.allow_view = true;
                nextRoleData[p.module_id] = m;
            });
            setHasUnsavedChanges(true);
            return { ...prev, [roleId]: nextRoleData };
        });
    };

    const handleGlobalSave = async () => {
        setLoading(true);
        try {
            const api = new DataApi("permissions/role");
            await Promise.all(Object.keys(editingPermissions).map(rid => 
                api.update({ role_id: rid === 'null' ? null : rid, permissions: Object.keys(editingPermissions[rid]).map(mid => ({ module_id: mid, ...editingPermissions[rid][mid] })) }, rid)
            ));
            PubSub.publish("RECORD_SAVED_TOAST", { message: "Saved Successfully" });
            setHasUnsavedChanges(false); setEditingPermissions({}); setRefreshKey(k => k + 1);
        } catch (e) { PubSub.publish("RECORD_ERROR_TOAST", { message: "Save failed" }); }
        setLoading(false);
    };

    if (loading && !modules.length) return <div className="text-center py-5">Loading...</div>;

    return (
        <div className="container-fluid permission-page">
            <CustomHeader rolePermissionsLength={rolePermissions.length} isExpanded={isExpanded} handleGlobalToggle={() => setIsExpanded(!isExpanded)} onAddNewRole={() => setShowAddModal(true)} />
            <div>
                {rolePermissions.map(role => (
                    <RoleAccordion key={role.role_id} role={role} 
                        expandedRoles={isExpanded ? rolePermissions.reduce((acc, r) => ({ ...acc, [r.role_id]: true }), {}) : expandedRoles}
                        handleRowToggle={(id) => setExpandedRoles(p => ({ ...p, [id]: !p[id] }))} 
                        modules={modules} moduleMap={moduleMap} editingPermissions={editingPermissions} 
                        handleSelectAllToggle={handleSelectAllToggle} handleInlineToggle={handleInlineToggle} 
                    />
                ))}
            </div>
            <div className="mx-3 pb-4 mt-2 d-flex justify-content-end">
                <Button onClick={handleGlobalSave} disabled={!hasUnsavedChanges} className="btn-paper shadow-sm px-3 py-2 fw-bold" style={{ background: hasUnsavedChanges ? '#0d6efd' : '#6c757d', color: '#fff', border: 'none' }}>
                 save
                </Button>
            </div>
            <AddPermissionModal show={showAddModal} handleClose={() => setShowAddModal(false)} onSave={() => setRefreshKey(k => k + 1)} />
        </div>
    );
};

export default Permission;